import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-input-close",
  "use": "icon-input-close-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-input-close\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h16v16H0z\" /><path d=\"M0 0h16v16H0z\" /><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1z\" /><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"m11.536 10.121-1.415 1.415-5.657-5.657L5.88 4.464z\" /><path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M5.879 11.536 4.464 10.12l5.657-5.657 1.415 1.415z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol